import React from 'react';
import { Pagination } from '@material-ui/lab';
// import { useMediaQuery, useTheme } from "@material-ui/core/styles";
import ArrowsIcon from '@material-ui/icons/UnfoldMore';
import { DividerContainer } from '../Divider';

import * as S from './PaginationStyles';

type PaginationPropsType = {
  count: number;
  rowsPerPage: number;
  page: number;
  setPage(page: number): void;
  setRowsPerPage(rows: number): void;
  rowsPerPageOptions?: number[];
};

export const TablePagination = ({ rowsPerPage, page, setPage, setRowsPerPage, count, rowsPerPageOptions = [5, 10, 25] }: PaginationPropsType) => {
  // const theme = useTheme();
  // const match = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  // const siblingCount = match ? 0 : 1;

  const currentPage = page + 1;

  return (
    <S.PaginationContainer className="pagination-container">
      <S.CountContainer>
        {rowsPerPage * currentPage - rowsPerPage + 1}-{Math.min(rowsPerPage * currentPage, count)} of {count}
      </S.CountContainer>
      <Pagination
        count={Math.ceil(count / rowsPerPage)}
        page={currentPage}
        siblingCount={1}
        variant="outlined"
        shape="rounded"
        onChange={(e, page) => {
          setPage(page - 1);
        }}
        renderItem={(item) => <S.StyledPaginationItem {...item} />}
      />
      <S.StyledButton disableRipple variant="outlined" color="primary">
        <S.StyledSelect
          value={rowsPerPage}
          onChange={(e) => {
            setPage(0);
            setRowsPerPage(Number(e.target.value));
          }}
        >
          {rowsPerPageOptions.map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </S.StyledSelect>
        <S.StyledIcon>
          <DividerContainer vertical />
          <ArrowsIcon />
        </S.StyledIcon>
      </S.StyledButton>
    </S.PaginationContainer>
  );
};
